export const TRANSLATIONS_EN = {
  email: "Email",
  password: "Password",
  forgotpassword: "Forgot password?",
  email_field_is_required: "Email field is required",
  reset_password: "Reset Password",
  password_field_is_required: "Password field is required",
  password_do_not_match: "Password do not match",
  invalid_email_address: "Invalid email address",
  leave_empty_to_keep_current: "Leave empty to keep current password",
  enter_email_address: "Enter email address",
  create_account: "Create Account",
  dont_have_an_account: "Don't have an account ?",
  already_have_an_account: "Already have an account?",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Enter the email address associated with your account and we will send you a link to reset your password.",
  back_to_login: "Back to login",
  activate_account: "Activate Account",
  activating_account: "Activating your account...",
  activation_success: "Account successfully activated!",
  activation_success_message: "Your account has been successfully activated. You can now log in.",
  activation_failed: "Activation failed",
  login: "Login",
  dashboard: {
    title: "Dashboard",
    view_trees: "View Trees",
    view_sensors: "View Sensors",
    greeting: "Hello",
    data_status: "Data status",
    all_locations: "All locations",
    last_30_days: "Last 30 days",
    top_species: "Top 5 Tree Species",
    top_species_info_title: "Top 5 Tree Species",
    top_species_info_body:
      "Shows the most frequent tree species in the current filters. Values are based on tree counts per species.",
    tasks_by_due_period: "Tasks by due period",
    view_tasks: "Open tasks",
    health_last_30_days: "Health last 30 days",
    tree_health: "Tree health",
    health_overview: "Overview",
    group_inventory: "Tree inventory",
    group_biometrics: "Tree biometrics",
    group_sensors: "Sensor status",
    group_recommendations: "Recommendations",
    kpi_total_trees: "Number of trees",
    kpi_total_species: "Number of tree species",
    kpi_total_sensors: "Number of sensors",
    kpi_sensor_types: "Sensor types",
    kpi_maintenance_sensors: "Implausible sensor readings",
    kpi_avg_height: "Average height",
    kpi_avg_trunk_circumference: "Average trunk circumference",
    kpi_avg_crown_diameter: "Average crown diameter",
    kpi_avg_age: "Average age",
    kpi_critical_sensors: "Critical sensors",
    kpi_disconnected_sensors: "Disconnected sensors (last 3 hours)",
    kpi_recommended_actions: "Trees with recommended action",
    sensor_types: "Sensor types",
    avg_height: "Average tree height",
    avg_trunk_diameter: "Average trunk diameter",
    avg_crown_diameter: "Average crown diameter",
    avg_age: "Average tree age",
    years_short: "years",
    last_3_hours: "last 3 hrs",
    no_data: "No data available",
    no_health_data: "No health data available",
  },

  // Tree Del Tabs
  tree_info: "Tree Info",
  no_photos: "No photos uploaded",
  greeting: "Hello",
  data_status: "Data status",
  top_species: "Top 5 Tree Species",
  tree_health: "Tree health",
  health_overview: "Health Overview",
  group_inventory: "Tree inventory",
  group_biometrics: "Tree biometrics",
  group_sensors: "Sensor status",
  kpi_total_trees: "Number of trees",
  kpi_total_species: "Number of tree species",
  kpi_total_sensors: "Number of sensors",
  kpi_sensor_types: "Sensor types",
  kpi_avg_height: "Average height",
  kpi_avg_trunk_diameter: "Average trunk diameter",
  kpi_avg_crown_diameter: "Average crown diameter",
  kpi_avg_age: "Average age",
  kpi_critical_sensors: "Critical sensors",
  kpi_disconnected_sensors: "Disconnected sensors (last 3 hours)",
  sensor_types: "Sensor types",
  years_short: "years",
  no_data: "No data available",
  no_health_data: "No health data available",
  top_species_info_title: "Most common tree species",
  top_species_info_body: "Shows the five most frequent tree species in your current selection.",

  newproject: "New Project",
  logout: "Log Out",
  viewproject: "View Project",
  users: "Users",
  persona: "Persona",
  username: "Username",
  save: "Save",
  saving: "Saving",
  addTree: "Add Tree",
  name: "Name",
  image: "Image",
  update: "Update",
  signup: "Signup",
  address: "Address",
  confirm: "Confirm",
  health_state: "Health State",
  project_details: {
    empty_project: "Empty Project, please start adding trees.",
    empty_trees: "Empty Trees, please start adding trees.",
    no_tree_selected: "Please select tree to view details",
    no_area_selected: "Please select area to view details",
    no_sensor_selected: "Please select a sensor to display details.",
    empty_sensors: "No sensors created, please start by adding sensors.",
  },

  user_details: {
    empty_project: "Empty User, please start adding trees.",
    no_user_selected: "Please select user to view details",
  },

  sensor_details: {
    empty_sensors: "Empty Sensor, please start adding trees.",
    no_sensor_selected: "Please select sensor to view details",
    no_data_found: "No Sensor Data Found",
    no_recent_measurements: "No measurements in the past 3 months.",
    no_recent_measurements_hint:
      "To inspect older data, use the data analysis view and adjust the time range.",
  },

  Set_the_report_of_the_project_with_the_help_of_the_pin:
    "Set the report of the project with the help of the pin",
  sensor: "Sensor",
  sensors: "Sensors",
  sensor_data: "Sensor Data",
  project: {
    name: "Project Name",
    aim: "Project Type",
    select_aim: "Select project type",
    description: "Project Description",
    description_placeholder: "Briefly describe the project",
    research_question: "Research Question",
    research_question_placeholder: "What is the central research question?",
    hypotheses: "Hypotheses to Test",
    hypotheses_placeholder: "What hypotheses should be tested?",
    methodology: "Methodology",
    methodology_placeholder:
      "Describe methodology, locations, tree selection, and sensor installation...",
    results: "Results",
    results_placeholder: "What are the main results of the project?",
    limitations: "Limitations of Results / Significance",
    limitations_placeholder: "How significant are the results? What are the limitations?",
    open_questions: "Open Questions / Next Steps",
    open_questions_placeholder: "What questions remain open? What are the next steps?",
    challenges: "Issues During the Project",
    challenges_placeholder: "What problems occurred? What did the customer need?",
    materials: "Files/Photos/Materials from the Project",
    materials_placeholder: "Links to files, photos, or other materials",
    aim_old_tree_monitoring: "Old Tree Monitoring",
    aim_irrigation_optimization_young_trees: "Irrigation Optimization: Young Trees",
    aim_technology_validation: "Technology Validation",
    aim_smart_city: "Smart City",
    aim_partnership_project: "Partnership Project",
    aim_irrigation_optimization: "Irrigation Optimization",
    aim_mistletoe_control: "Mistletoe Control",
    aim_groundwater_lowering_monitoring: "Groundwater Lowering Monitoring",
    aim_general_drought_stress_monitoring: "General Drought Stress Monitoring",
    aim_irrigation_demand_determination: "Irrigation Demand Determination",
  },

  aim: "Project Aim",
  select_aim: "Select project aim",
  description: "Project Description",
  description_placeholder: "Briefly describe the project",
  research_question: "Research Question/Project Objectives",
  research_question_placeholder: "What is the main question or objective of this project?",
  hypotheses: "Hypotheses to Test",
  hypotheses_placeholder: "What hypotheses should be tested?",
  methodology: "How to Answer the Question? (Methodology, Tree Selection, Installation)",
  methodology_placeholder:
    "Describe methodology, locations, tree selection, sensor installation...",
  results: "Results",
  results_placeholder: "What are the main results of the project?",
  limitations: "Limitations of Results / Significance",
  limitations_placeholder: "How significant are the results? What are the limitations?",
  open_questions: "Open Questions / Next Steps",
  open_questions_placeholder: "What questions remain open? What are the next steps?",
  challenges: "Problems During Project / Future Challenges",
  challenges_placeholder: "What problems occurred? What did the customer need?",
  materials: "Files/Photos/Materials from the Project",
  materials_placeholder: "Links to files, photos, or other materials",
  aim_irrigation_demand_determination: "Irrigation Demand Determination",
  projects: "Projects",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  trees: "Trees",
  tree: "Tree",
  species: " Species",
  genus: "Genus",
  customers: "Customers",
  customer: "Customer",
  tasks: "Tasks",
  task_suggestions_title: "Suggested Tasks",
  task_suggestions_empty: "No pending suggestions.",
  task_suggestions_pending_count: "pending suggestions",
  task_suggestions_open_page: "Open suggestions",
  task_suggestion_create_task: "Create Task",
  task_suggestion_dismiss: "Dismiss",
  task_suggestion_bulk_create: "Create selected",
  task_suggestion_bulk_dismiss: "Dismiss selected",
  task_suggestion_bulk_created_success: "Selected suggestions created.",
  task_suggestion_bulk_dismissed_success: "Selected suggestions dismissed.",
  task_suggestion_created: "Created",
  task_suggestion_created_success: "Task created from suggestion.",
  task_suggestion_dismissed_success: "Suggestion dismissed.",
  task_suggestion_health_red: "Red",
  task_suggestion_health_yellow: "Yellow",
  task_suggestion_reason_fallback: "Health status requires attention.",
  task_suggestion_choose_assignee_title: "Choose responsible person",
  task_suggestion_choose_assignee_body:
    "Choose who should be assigned when accepting this irrigation suggestion.",
  task_suggestion_choose_assignee_validation: "Please select a person.",
  task_suggestion_bulk_manual_only:
    "In manual mode, irrigation suggestions can only be accepted one by one.",
  select_all: "Select all",
  deselect_all: "Deselect all",
  clear: "Clear",
  with_sensor: "With Sensor",
  without_sensor: "Without Sensor",
  active_installation: "Active Installation",
  no_installation: "No Installation",
  filter_by_location: "Filter by Location",
  active_sensor_installation: "Active Sensor Installation",
  irrigation_settings: "Irrigation",
  irrigation_trigger_conditions: "Trigger Conditions",
  irrigation_trigger_yellow: "Trigger when Health State is Yellow",
  irrigation_trigger_red: "Trigger when Health State is Red",
  irrigation_trigger_after_days: "Trigger after X days",
  irrigation_auto_create_task: "Automatically create task (skip suggestion)",
  irrigation_suggestion_assignment_mode_title: "Assignment for suggestions",
  irrigation_suggestion_assignment_mode_hint:
    "Choose whether irrigation suggestions should use the default responsible person per area or require manual selection on each acceptance.",
  irrigation_suggestion_assignment_mode_area_default: "Default responsible person per area",
  irrigation_suggestion_assignment_mode_manual:
    "Manually choose responsible person on each acceptance",
  irrigation_default_volumes: "Default Irrigation Volumes",
  development_phase: "Development Phase",
  irrigation_phase_default: "No Phase (Default)",
  default_liters: "Default Liters",
  irrigation_interval_title: "Irrigation Interval",
  irrigation_interval_daily: "Daily",
  irrigation_interval_weekly: "Weekly",
  irrigation_interval_biweekly: "Every 2 Weeks",
  irrigation_interval_custom: "Custom (X days)",
  irrigation_repeat_every: "Repeat every",
  irrigation_stop_condition_title: "Stop Condition",
  irrigation_stop_until_green: "Continue until Health State returns to Green",
  irrigation_stop_fixed_cycles: "Fixed number of cycles",
  irrigation_cycle_count_label: "Number of irrigation cycles",
  irrigation_area_assignees_title: "Responsible person per area",
  irrigation_area_assignees_hint:
    "Define who should be assigned by default for automatically created or prepared irrigation tasks per area.",
  irrigation_no_areas: "No areas available.",
  save_settings: "Save Settings",
  irrigation_settings_saved: "Irrigation settings saved.",
  irrigation_validation_custom_days: "Please enter a valid custom interval in days.",
  irrigation_validation_fixed_cycles: "Please enter a valid fixed cycle count.",
  files_selected: "Files selected",
  past_tasks: "Past",
  future_tasks: "Future",
  tree_phases: "Tree phases",
  health_states_title: "Health status",
  task: "Task",
  add_task: "Add Task",
  edit_task: "Edit Task",
  task_details: "Task Details",
  select_task_types: "Select task types",
  print_tree_tag: "Print Tree Tag",
  tree_photos: "Tree Photos",
  leaf_photos: "Leaf Photos",
  confirm_delete_image: "Are you sure you want to delete this image?",
  data_science: "Data Science",
  map_view: "Map View",
  map_add_tree_mode: "Positioning mode active",
  map_add_tree_hint: "Move the map to set the tree location.",
  select_project: "Select Project",
  choose_project: "Choose a project",
  please_select_project: "Please select a project to view data",
  please_select_project_to_view_map: "Please select a project to view the map",
  ds_fetch_error_message:
    "Could not load the selected time-series data. The selected time range or number of sensors may be too large.",
  ds_fetch_error_hint: "Please reduce the date range, select fewer sensors, or try again.",
  ds_pending_reload_message:
    "The graph is hidden because your selection changed and the data has not been reloaded yet.",
  ds_pending_reload_hint: 'Click "Load Data" to refresh the chart.',
  ds_no_data_message: "No data available",
  ds_no_data_hint: "No values were found for the selected filters and time range.",
  ds_enter_fullscreen: "Focus mode",
  ds_exit_fullscreen: "Exit focus mode",
  no_project_selected: "No project selected",
  show_tree_list: "Show Tree List",
  show_all_trees: "Show All Trees",
  all_trees: "All Trees",
  no_trees_found: "No trees found",

  actions: "Actions",
  battery: "Battery",
  threshold: "Threshold",
  settings: "Settings",
  tour_start: "Start Tour",
  help: "Help",
  feedback: "Feedback",
  api_documentation: "API Documentation",
  wiki_help: "Wiki & Guides",
  without_project: "Without Project",
  without_location: "Without Location",
  no_projects_available: "No projects available",
  reporting: "Reporting",
  feedback_problem_url: "Problem URL",
  feedback_category: "Category",
  feedback_category_bug: "Bug Report",
  feedback_category_positive: "Positive Feedback",
  feedback_category_feature_request: "Feature Request",
  feedback_priority: "Priority",
  feedback_priority_low: "Low",
  feedback_priority_medium: "Medium",
  feedback_priority_high: "High",
  feedback_priority_critical: "Critical",
  feedback_screenshot: "Screenshot",
  feedback_description: "Description",
  send_feedback: "Send Feedback",
  feedback_submit_success: "Feedback saved successfully.",
  download_excel: "Download Excel",
  download_pdf: "Download PDF",
  download_csv: "Download CSV",
  report_date: "Date",
  report_sensor_tab: "Sensor Report",
  report_kataster_tab: "Kataster Report",
  report_effect_tab: "Effect Report",
  report_range_1w: "1 Week",
  report_range_1m: "1 Month",
  report_range_3m: "3 Months",
  report_range_1y: "1 Year",
  all_areas: "All areas",
  all_species: "All species",
  all_responsible: "All responsible",
  report_total_active_sensors: "Total active sensors",
  report_offline_sensors: "Offline sensors",
  report_avg_moisture_index: "Average moisture index",
  report_critical_trees: "Critical trees",
  report_batteries_low: "Batteries < 20%",
  report_threshold_violations: "Threshold violations",
  report_avg_moisture_over_time: "Average moisture index over time",
  report_health_distribution: "Health status distribution",
  report_rain_vs_index: "Rain vs average index",
  report_violations: "Violations",
  report_total_trees: "Total trees",
  report_controls_performed: "Controls performed",
  report_overdue_tasks: "Overdue tasks",
  report_completed_tasks: "Completed tasks",
  report_documented_maintenance: "Documented maintenance actions",
  report_avg_control_interval: "Average control interval",
  report_task_status_distribution: "Task status distribution",
  report_controls_per_month: "Controls per month",
  report_maintenance_type_distribution: "Maintenance type distribution",
  report_critical_with_open_task: "Critical trees with open task",
  report_avg_violation_to_completion: "Avg. violation to task completion",
  report_index_change_after_irrigation: "Index change after irrigation",
  report_index_change_after_pruning: "Index change after pruning",
  report_before_after_analysis: "Before/after analysis",
  report_before: "Before",
  report_after: "After",
  report_irrigation_vs_index: "Irrigations vs average index",
  report_critical_vs_completed: "Critical trees vs completed measures",
  due_date: "Due date",
  reason: "Reason",
  impact: "Impact",
  rainfall: "Rainfall",
  index: "Index",
  completed: "Completed",
  notifications: "Notifications",
  mark_all_as_seen: "Mark all as Seen.",
  showing: "Showing",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "The unique identification of the sensor. It can be found on the sticker on the transmitter module. For LoRaWAN sensors it is the DevEUI and for NB-IoT sensors it is the IMEI.",
  dev_eui: "DevEUI",
  imei: "IMEI",
  add_sensor: "Add Sensor",
  add_user: "Add User",
  edit_sensor: "Edit Sensor",
  push_message_notification: "Push Message Notifications",
  email_notification: "E-Mail Notifications",
  email_schedule: "E-Mail Schedule",
  weekly_summary_email: "Weekly summary email",
  daily_changes_email: "Daily changes email",
  manage_users_description: "Manage user accounts and permissions",
  manage_customers_description: "Manage customer information and access",
  statistics: "Statistics",
  customer_statistics_description: "View customer statistics and data overview",
  go_to_users: "Go to Users",
  go_to_customers: "Go to Customers",
  tree_with_sensor: "Tree with Sensor",
  represented_tree: "Represented Tree",
  tree_without_sensor: "Tree without Sensor",
  sensor_status_change_to_no_connection: "Sensor status change to no connection",
  sensor_status_change_to_dry: "Sensor status change to dry",
  sensor_status_change_to_drying_out: "Sensor status change to drying out",
  treespecies: "Tree Species",
  treegenus: "Tree Genus",
  skip: "Skip",
  notes: "Notes",
  latitude: "Latitude",
  longitude: "Longitude",
  trunk_circumference: "Trunk Circumference",
  planting_year: "Planting Year",
  select_year: "Choose Year",
  crown_diameter: "Crown Diameter",
  represent_tree: "Represent Tree",
  planting_time: "Planting Time",
  altitude: "Altitude",
  height: "Height",
  location: "Location",
  reference: "Reference",
  invalid_date: "Invalid date",
  error: {
    this_field_is_required: "This field is required",
    name_field_is_required: "Name field is required",
    please_choose_species: "Please choose species",
    please_choose_genus: "Please choose genus",
    choose_location: "Choose Location",
    hardware_serial_no_is_required: "Hardware serial no is required",
    a_valid_threshold_is_required: "A valid threshold is required",
    form: "The values were entered incorrectly. Please correct them and try again",
    something_went_wrong: "Something went wrong",
  },

  first_name: "First Name",
  last_name: "Last Name",
  profile: "Profile",
  phone_number: "Phone number",
  account_type: "Account Type",
  city: "City",
  street_name: "Street Name",
  house_number: "House Number",
  country: "Country",
  zip_code: "Zip Code",
  day: {
    sun: "Sunday",
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
  },

  end: "End Date",
  admin: "Admin",
  basic: "Basic",
  add_existing_tree: "Add Existing Tree",
  phase: "Phase",
  Youngphase: "Youth phase",
  Oldphase: "Ageing phase",
  Midphase: "Maturity phase",
  select_phase: "Select Phase",
  health_states: {
    healthy: "Healthy",
    healthy_todo: "The Tree has a good water supply. You do not need to take any action.",
    wet: "Too Wet",
    wet_todo: "The Tree or Soil is too wet. Do no irrigation the tree.",
    medium: "Medium",
    medium_todo: "",
    critical: "Critical",
    critical_todo:
      "The Tree most probably suffers from drought stress. Irrigate it as soon as possible.",
    dry: "Dry",
    dry_todo: "The tree needs to be watered or checked as soon as possible.",
    frost: "Frost",
    frost_todo: "The tree could have frost damage.",
    disconnect: "Disconnect",
    drying_out: "Drying out",
    drying_out_todo: "The tree should be watered.",
    too_wet: "Too wet",
    too_wet_todo: "The tree or soil appears to be too wet and should not be watered.",
    unknown: "Unknown",
    unknown_todo: "The sensor should be checked.",
    no_sensor: "No Sensor",
    no_sensor_todo: "No sensor installed. Install a sensor to monitor water stress.",
    no_data: "No Data",
    no_data_todo: "Sensor is installed but not sending data. Check the sensor connection.",
    maintenance_needed: "Implausible sensor readings",
    maintenance_needed_todo: "Sensor readings appear implausible. Check and maintain the sensor.",
    priority_title: "How is the status calculated?",
    priority_explanation: "The health status is based on a priority system:",
    priority_1_crown: "Crown sensors (if present, only these count)",
    priority_2_soil: "Soil sensors (only if no crown sensors)",
    priority_3_dendrometer: "Dendrometer (only if no other sensors)",
    priority_note:
      "💡 In the detail view you can see all sensors. However, the tree status is only determined by the highest available priority.",
    soil_needs_attention: "Soil sensors show critical values even though the crown is healthy",
    mixed_sensors: "Sensors show different states",
    status_from_crown:
      "Status based on crown sensor: {{crownStatus}}\n(Soil sensor: {{soilStatus}} - for information only)",
    status_from_soil: "Status based on soil sensor (no crown sensors present)",
    determines_tree_status: "This sensor determines the tree status",
    info_only: "For information only, does not determine tree status",
  },

  tree_water_stress: "Water Stress",
  tree_status: "Tree Status",
  tree_cadastre_no: "Tree Cadastre No",
  crown: "Crown",
  soil: "Soil",
  overall: "Overall",
  health_priority: "Priority",
  note: "Note",
  active: "active",
  usable: "usable",
  defect_sensor: "Defect sensor present",
  defect_sensors_excluded: "Defect sensors are excluded from calculation",
  defect_sensors_info:
    "Defect or unreachable sensors (shown in gray) are not considered in the health calculation. Only working sensors contribute to the status.",
  export: "Export",
  export_data: "Export data",
  no_data_to_export: "No data to export",
  problem_in_creating_customer: "Problem in creating customer",
  problem_in_creating_sensor: "Problem in creating sensor",
  select_customer_type: "Select Customer Type",
  assign_to_tree: "Assign to tree",
  choose_tree: "Choose Tree",
  customer_type: "Customer Type",
  customer_type_agriculture: "Agriculture",
  customer_type_city: "City",
  customer_type_forestry: "Forestry",
  customer_type_science: "Science",
  import_trees: "Import Trees",
  choose_file: "Choose File",
  upload: "Upload",
  choose_the_file_to_be_imported: "Choose the file to be imported",
  upload_tree: "Upload Tree",
  change_image: "Change Image",
  update_image: "Update Image",
  update_customer_logo_description: "Upload and update your organization logo",
  tree_added_successfully: "Tree added successfully",
  change_language: "Change language",
  appearance: "Appearance",
  theme: "Theme",
  theme_description: "Choose how TreeSense looks to you",
  theme_light: "Light",
  theme_light_desc: "Bright and clear",
  theme_dark: "Dark",
  theme_dark_desc: "Easy on the eyes",
  theme_system: "System",
  theme_system_desc: "Follows your device",
  current_theme: "Current theme",
  language_description: "Select your preferred language",
  saved: "Saved",
  total_trees: "Total no of trees",
  total_trees_species: "Total no of Tree Species",
  total_sensors: "Total no of sensors",
  critical_sensors: "Total no of critical sensors",
  number_of_tree_on_respective_area: "Number of tree on respective area",
  number_of_tree_based_on_health_status: "Number of tree based on health status",
  time: "Time",
  maintainance: "Maintainance",
  type_of_maintenance: "Type of maintenance",
  custom_maintenance_type: "Custom maintenance type",
  add_your_own_maintenance: "Add your own maintenance",
  disconnected_sensors: "Disconnected Sensors",
  write_something: "Write Something...",
  write_some_notes_on_action_performed: "Write some notes on action performed...",
  search_sensor: "Search Sensor",
  search_sensors: "Search sensors...",
  search_trees: "Search trees...",
  showing_results: "Showing {{count}} results",
  resistance: "Resistance",
  water_soil: "Soil Moisture",
  irrigation: "Irrigation",
  crown_care: "Crown Care",
  tree_control: "Tree Control",
  weed_removal_root: "Weed Removal Root",
  ligature_control: "Ligature Control",
  trunk_protection: "Trunk Protection",
  tree_stakes_control: "Tree Stakes Control",
  clearance_profile_pruning: "Clearance Profile Pruning",
  deadwood_removal: "Deadwood Removal",
  stem_cane_removal: "Stem Cane Removal",
  topiary: "Topiary",
  head_purning: "Head Pruning",
  either_fill_all_address_or_make_all_empty: "Either fill all address or make all empty",
  search_tree: "Search Tree",
  mark_as_Seen: "Mark as seen",
  tick_the_checkbox_to_download_data: "Tick the checkbox to download data  ",
  download_sensor_data: "Download sensor data",
  export_sensor_description: "Export the available sensor measurements for the selected timeframe.",
  include_advanced_calibration_values: "Include advanced calibration/debug values",
  include_mean_values: "Include mean values",
  include_mean_values_hint: "Adds averaged values for the selected timeframe to the export.",
  sensor_name: "Sensor name",
  temperature: "Temperature",
  rain: "Rain",
  loading_data: "Loading data ...",
  align_qr_code_within_the_frame: "Align QR code within the frame",
  gallery: "Gallery",
  scan_to_add_sensor: "Scan to add sensor",
  choose_qr_to_scan: "Choose QR to scan",
  pulse_resistance_in_kOhm: "Pulse Resistance in kOhm",
  loading: "Loading ...",
  irrigationArea: "Irrigation Area",
  button: {
    back: "Back",
    next: "Next",
    save: "Save",
    reset: "Reset",
    saving: "Saving ...",
    update: "Update",
    updating: "Updating ...",
    add_tree: "Add Tree",
    add_sensor: "Add Sensor",
    import_tree: "Import Tree",
    add_irrigation_area: "Add Irrigation Area",
    add_customer: "Add Customer",
    edit_customer: "Edit Customer",
    add_all: "Add Tree with Components",
    cancel: "Cancel",
  },

  choose_location: "Choose Location",
  tree_form: {
    sensors: "Sensors",
    position: "Position",
    more_info: "More Info",
    tree_profile: "Tree Profile",
    representTree: "Child Trees",
    soil: "Soil",
    info: {
      represent: {
        heading: "Representative tree",
        help: "Select the tree that represents this location for analysis and reporting.",
        note: "To analyse the data as accurately as possible, we recommend uploading a photo of the tree and a representative leaf at the same time.",
      },
      sensors: {
        heading: "Sensors",
        help: "Assign the sensors that belong to this tree.",
        note: "The selected sensors are used to display live data and calculate watering recommendations.",
      },
      soil: {
        heading: "Soil parameters",
        max_f_help: "Maximum sensor value for well-watered trees (F = irrigated).",
        max_f_label: "Max. value (irrigated trees)",
        max_nf_help: "Maximum sensor value for non-irrigated trees (NF = not irrigated).",
        max_nf_label: "Max. value (non-irrigated trees)",
        note: "These thresholds are used to derive watering recommendations and traffic-light colours.",
        pwp_help: "Sensor value at which the tree reaches the permanent wilting point (PWP).",
        pwp_label: "Permanent wilting point (PWP)",
      },
    },
  },
  user_form: {
    profile: "Profile",
    address: "Address",
    basic_info: "Basic Info",
    login_credentials: "Login Credentials",
    areas: "Irrigation Areas",
  },

  sensor_form: {
    name: "Name",
    threshold: "Threshold",
    hardware_serial: "Hardware Serial",
    sensor_type: "Sensor Type",
    network_type: "Network Type",
  },

  task_form: {
    basic_info: "Basic Info",
    assignment: "Assignment",
    title: "Title",
    title_placeholder: "Enter task title",
    description: "Description",
    description_placeholder: "Enter task description",
    priority: "Priority",
    priority_low: "Low",
    priority_medium: "Medium",
    priority_high: "High",
    status: "Status",
    status_pending: "Pending",
    status_in_progress: "In Progress",
    status_completed: "Completed",
    tree: "Tree",
    assigned_to: "Assigned To",
    due_date: "Due Date",
    created_at: "Created At",
    created_by: "Created By",
    select_task_to_view: "Select a task to view details",
    select_user: "Select User",
  },

  add_all_form: {
    title: "Add tree with sensor in area",
    sensor: {
      title: "Sensor",
      explanation:
        "Do you want to a Sensor add an existing Tree or do you want to create a new one?",
      new_sensor: "Add a new Sensor",
      existing_sensors: "Choose existing Sensors",
    },
    tree_info: "Tree Info",
    traffic_safety: "Safety",
    tree: {
      title: "Tree",
      explanation:
        "Do you want to add an existing Tree or do you want to create a new one?Hier kann ein neuer Sensor erstellt und dem Baum hinzugefügt werden. Oder aber ein bereits bestehender Sensor kann ausgewählt werden, um ihn dem hinzuzufügen.",
      new_tree: "Create a new Tree",
      existing_tree: "Choose an existing Tree",
    },

    area: {
      title: "Area",
      explanation:
        "Do you want to add the Tree to an existing Area or do you want to create a Area and add the Tree to it?",
      new_area: "Create a new Area",
      existing_area: "Choose an existing Area",
    },
    no_photos: "No photos uploaded",
  },

  create_new_tree: "Create new Tree",
  validation: {
    email_is_required: "Email is required",
    password_is_required: "Password is required",
    invalid_email_address: "Invalid email address",
    name_is_required: "Name is required",
    hardware_serial_is_required: "Hardware serial is required",
    user_with_this_email_already_exist: "User with this email already exist",
    all_address_field_are_required: "All address field are required",
    position_is_required: "Position is required",
    invalid_house_number: "Invalid house number",
    user_limit_exceeded_for_your_package: "User limit exceeded for your package",
    sensor_limit_exceeded_for_your_package: "Sensor limit exceeded for your package",
    tree_limit_exceeded_for_your_package: "Tree limit exceeded for your package",
    invalid_hex_identifier:
      "The identifier must be a valid uppercase hexadecimal value. Please use only digits 0–9 and capital letters A–F.",
    imei_must_be_15_digits: "IMEI must be exactly 15 digits.",
    hardware_serial_must_be_16_characters: "Hardware serial must be exactly 16 characters.",
    must_be_a_number: "Value must be a number",
    out_of_range: "Value must be between {{min}} and {{max}}",
    task_error: "Task is required.",
    cadastre_or_name_required: "Either Tree Cadastre No or Tree Name must be provided.",
    either_field_required: "* At least one of these fields is required.",
    required_fields: "* Required fields",
  },
  drag_the_below_variables_to_graph_area: "Drag the below variables to graph area",
  drop_left: "Drop Left",
  drop_right: "Drop Right",
  drop_the_variable_to_get_data: "Drop the variable. Go on!",
  no_data_available_please_check_data_available_to_this_date:
    "No data available, please check data available to this date",
  unable_to_upload_file: "Unable to upload file",
  file_upload_successfully: "File upload successfully",
  no_tree_is_selected: "No tree is selected",
  no_sensor_is_selected: "No sensor is selected",
  areaName: "Name",
  childTree: "Child Tree",
  add_child_tree: "Add child tree",
  parentTree: "Parent Tree",
  area: "Area",
  areas: "Areas",
  start_with_adding_new_project: "Start with adding new project",
  resis_temp_comp: "ResisTempComp",
  health_of_tree_is_good: "Health state of tree is good",
  health_of_tree_is_drying_out: "Health of tree is drying out",
  health_of_tree_is_poor: "Health of tree is poor",
  sensor_disconnect: "Sensor disconnect",
  battery_full: "Battery full",
  less_than_60_of_the_battery_remaining: "Less than 60% of the battery remaining",
  battery_is_getting_low: "Battery is getting low",
  size: "Size",
  type: "Type",
  records: "Records",
  pagination_out_of: "out of",
  status: "Status",
  welcome_back: "Welcome Back!",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Looks like you don't have selected  area. Please select an area to get data.",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Looks like you don't have selected tree. Please select a tree to get data.",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Looks like you don't have selected  sensor. Please select a sensor to get data.",
  please_drag_the_variable_to_display_data: "Please drag the variable to display data.",
  click_on_marker_to_select_tree: "Click on marker to select tree",
  next_irrigation: "Next Irrigation",
  mean: "Mean",
  default: "Default",
  default_legacy: "Default, legacy",
  sensor_state: "Sensor State",
  state: "State",
  moisture_content: "Treesense Moisture Index",
  drought_days: "Drought Days",
  formula_type: "Formula",
  calibration_species: "Calibration species",
  calibration_species_tooltip:
    "The calibration model used for this species to calculate the moisture index",
  calibration_species_no_mapping: "No species mapping available",
  calibration_species_unknown_tree_species: "Tree species missing",
  calibration_species_legacy_settings_hint: "The legacy black poplar calibration is being used.",
  calibration_species_settings_hint:
    "If no mapping is shown here or the legacy formula is still active, this can be updated under Settings > Customer > Moisture content formula.",
  calibration_species_settings_link: "Open settings",
  card_number: "Card Numer",
  card_name: "Card Name",
  expiration_date: "Expiration Date",
  continue: "Continue",
  today: "Today",
  tomorrow: "Tomorrow",
  days_left: "days left",
  days: "Days",
  personal_data: "Personal data",
  basic_user_projects_hint:
    "You can assign full projects here. All locations/areas belonging to the selected projects will be included.",
  basic_user_areas_hint:
    "Basic users should be assigned one or more areas/locations. Without assignments, their accessible data is limited.",
  user_invitation_email_hint:
    "After saving, the user will receive an email to set their own password.",
  persona_labels: {
    tree_inspector: "Tree Inspector",
    irrigation_team: "Irrigation Team",
    city_tree_manager: "City Tree Manager",
    research_partner: "Research Partner",
    treesense_support: "TreeSense Support",
  },
  settings_user_info: {
    persona_section_title: "What this changes in the UI",
    role_section_title: "What this changes in access",
    persona_footer:
      "Personas shape the default entry point and UX focus. Effective access still comes from the backend role permissions.",
    role_footer:
      "Roles determine the effective permissions. Personas only influence default navigation and UX focus.",
    persona: {
      tree_inspector: {
        description:
          "UX profile for users who mainly work in the tree cadastre and carry out inspections in the field.",
        changes: ["Default page: Tree cadastre", "Focus: inspections, tree records and field work"],
      },
      irrigation_team: {
        description:
          "UX profile for users who mainly work in task-driven irrigation and execution workflows.",
        changes: ["Default page: Tasks", "Focus: watering workflows and operational execution"],
      },
      city_tree_manager: {
        description:
          "UX profile for users who need a management-oriented overview across dashboard, cadastre and analytics.",
        changes: [
          "Default page: Dashboard",
          "Focus: overview, cadastre and reporting-oriented work",
        ],
      },
      research_partner: {
        description:
          "UX profile for users who mainly work in Data Science and sensor-based analysis.",
        changes: ["Default page: Data Science", "Focus: exploration, sensor data and analysis"],
      },
      treesense_support: {
        description:
          "UX profile for users who mainly monitor sensors and handle technical support processes.",
        changes: ["Default page: Sensors", "Focus: sensor status and technical support workflows"],
      },
    },
    role: {
      superuser: {
        description:
          "Full administrative role with unrestricted access to configuration and management areas.",
        changes: [
          "Can manage users, settings and customer-level administration",
          "Typically has the widest access across modules",
        ],
      },
      admin: {
        description:
          "Administrative role for customer-level management and organisational workflows.",
        changes: [
          "Can manage organisational workflows without full platform ownership",
          "Usually has broad customer-level access depending on backend permissions",
        ],
      },
      basic: {
        description:
          "Operational end-user role for day-to-day work in assigned projects and areas.",
        changes: [
          "Works inside assigned projects and areas",
          "Area assignments are especially relevant for operational access",
        ],
      },
    },
  },
  language: "Language",
  change_logo: "Change logo",
  role: "Role",
  amount_nodes: "Amount sensor nodes",
  last_battery: "Last Battery",
  characters: "Characters",
  maximum_of: "Maximum",
  stop_scanning: "Stop Scanning",
  last_measurements: "Last Measurements",
  adjust_thresholds_crown: "Adjust Thresholds for the Crown Sensors",
  adjust_thresholds_soil: "Adjust Thresholds for the Soil Sensors",
  set_default: "Set Default",
  meaning_measurement: "Meaning of Measurement",
  download_tree_list: "Download Tree List (.xlsx)",
  download_tree_details: "Download Details of Trees (.pdf)",
  not_provided: "Not provided",
  soil_moisture_edit: "Thresholds vol. Soil Moisture",
  soil_water_tension_edit: "Thresholds Soil Water Tension",
  select_language: "Select Language",
  login_credentials: "Login Credential",
  user: "User",
  child_trees: "Child Trees",
  last_value: "Last Value",
  weather: "Weather",
  edit_user: "Edit User",
  Profile: "Profile",
  Manual: "Manual",
  of: "of",
  the: "the",
  Menu: "Menu",
  superuser: "Super User",
  sending: "Sending...",
  Dry: "Dry",
  Dryingout: "Drying Out",
  Healthy: "Healthy",
  Wet: "Wet",
  Unknown: "Unkown",
  dendrometer: "Dendrometer",
  diameter: "Diameter",
  network_type: "Network Type",
  sensor_type: "Sensor Type",
  lora_wan: "LoRaWAN",
  nb_iot: "NB-IoT",
  area_form: {
    existing_area: "Existing area",
  },

  new_area: "New Area",
  existing_area: "Existing Area",
  explanation: "Explanation",
  add_area: "Add Area",
  battery_empty: "Battery Empty",
  maintenance_needed: "Implausible sensor readings",
  All: "All",
  tree_count: "Tree Count",
  demo_project_warning: {
    title: "Demo Account",
    description:
      "You are currently using a demo account and have limited permissions.\nIf you are already a customer and would like access to your customer account, please contact support: support@treesense.net.\nIf you are not yet a customer, you can order sensors through our shop at https://www.treesense.net",
  },
  add_tree_img: "Add Tree Image",
  datetime_photo: "Time of image capture",
  upload_tree_img: "Upload Tree Image",
  upload_leaf_img: "Upload Leaf Image",
  upload_3d_model: "Upload 3D model",
  replace_3d_model: "Replace 3D model",
  remove_3d_model: "Remove 3D model",
  pulse_sensor: "Pulse Sensor",
  soil_moisture_sensor: "Soil Moisture Sensor",
  soil_moisture: "Soil Moisture",
  soil_moisture_vg: "Soil Moisture (van Genuchten)",
  soil_water_tension_sensor: "Soil Water Tension Sensor",
  soil_water_tension: "Soil Water Tension",
  soil_water_tension_vg: "Soil Water Tension (van Genuchten)",
  dendrometer_sensor: "Dendrometer Sensor",
  views_per_page: "View per Page",
  customer_attributes: "Customer Attributes",
  tree_profile: {
    tree_species_knowledge: "Facts",
    tree_species: "Interesting Facts",
    tree_info: "Tree Information",
    learn_more: "Click here to learn more",
  },

  root_system: {
    UN: "Unknown",
    SH: "Shallow-rooted",
    DE: "Deep-rooted",
    HE: "Heart-rooted",
  },

  latin_name: "lat. Name",
  german_name: "ge. Name",
  tree_species: "Tree Species",
  depth: "Depth",
  root_ball: "Root ball",
  healthy: "Healthy",
  okay: "Okay",
  critical: "Critical",
  not_sending: "Not Sending",
  working: "Working",
  unknown: "Unknown",
  defect: "Defect",
  add_installation: "Add Installation",
  select_sensor: "Select Sensor",
  select_depth: "Select Depth",
  installed_at: "Date of Installation",
  removed_at: "Date of Removal",
  hardware_serial_no: "Hardware Serial",
  required_information: "* Required Information",
  include_calculated_values: "include calculated values",
  calculated_values_wip:
    "The calculated values (moisture_content, resis_temp_comp) are still work in progress. Please use them with caution. Please select if you want to download the calculated values as well.",
  last_10_measurements: "Last 10 measurements",
  soil_name: "Soil Name",
  optional_soil_name: "Optional soil name",
  tree_name: "Tree Name",
  permanent_wilting_point: "Permanent wilting point",
  effective_field_capacity: "Effective field capacity",
  field_capacity: "Field capacity",
  sensor_status: "Sensor Status",
  sensor_status_description:
    "The sensor status indicates whether the sensor is working or whether it requires maintenance",
  timeframe: "Timeframe",
  timeframe_hint:
    "Leave as-is to download the last 30 days. Adjust the range to narrow your export.",
  include_new_moisture_content_data: "Include new moisture content (species mapping)",
  include_old_moisture_content_data: "Include old moisture content (schwarzpappel)",
  include_species_mapping_data: "Additionally include species mapping calibration data",
  file_download_success: "File has been downloaded successfully!",
  export_failed: "Export failed. Please try again.",
  no_data_for_selected_range: "No data available for the selected time range and parameters.",
  invalid_date_range: "Start date must be before end date.",
  one_year: "1 Year",
  six_months: "6 Months",
  three_weeks: "3 Weeks",
  one_week: "1 Week",
  one_day: "1 Day",
  custom_range: "Range",
  open_time_controls: "Open time controls",
  close_time_controls: "Close time controls",
  filters: "Filters",
  time_range_selection: "Time Range Selection",
  time_range_info:
    "Select a time range to view historical data. Choose from preset ranges or define a custom period.",
  one_year_info: "Display data from the last 12 months",
  six_months_info: "Display data from the last 6 months",
  three_weeks_info: "Display data from the last 3 weeks",
  one_week_info: "Display data from the last 7 days",
  one_day_info: "Display data from the last 24 hours",
  custom_range_info: "Select a custom date and time range",
  reset_chart: "Reset Chart",
  reset_info: "Reset all chart settings to default",
  interval_settings: "Interval",
  data_interval_settings: "Data Interval Settings",
  data_interval_description: "Specify how data points should be grouped in the chart.",
  close: "Close",

  // Traffic Safety Module
  traffic_safety_assessments: "Traffic Safety Assessments",
  add_assessment: "Add Assessment",
  edit_safety_assessment: "Edit Safety Assessment",
  add_safety_assessment: "Add Safety Assessment",
  no_safety_assessments: "No safety assessments recorded",
  traffic_safety_status: "Traffic Safety Status",
  defect_types: "Defect Types",
  structural_defects: "Structural Defects",
  root_defects: "Root Defects",
  trunk_defects: "Trunk Defects",
  crown_defects: "Crown Defects",
  fungal_infection: "Fungal Infection",
  pest_infestation: "Pest Infestation",

  safety_status: {
    safe: "Safe",
    monitoring_required: "Monitoring Required",
    action_required: "Action Required",
    unsafe: "Unsafe",
  },

  risk_level: {
    low: "Low Risk",
    medium: "Medium Risk",
    high: "High Risk",
    critical: "Critical Risk",
  },

  // VTA Assessment Module
  vta_assessments: "VTA Assessments",
  add_vta: "Add VTA Assessment",
  edit_vta: "Edit VTA Assessment",
  no_vta_assessments: "No VTA assessments recorded",
  assessor: "Assessor",
  vitality_stage: "Vitality Stage",
  vitality_stage_help: "0 = Vital, 1 = Slightly weakened, 2 = Weakened, 3 = Severely weakened",
  crown_vitality: "Crown Vitality",
  dieback: "Dieback",

  // Inspection Module
  inspections: "Inspections",
  add_inspection: "Add Inspection",
  edit_inspection: "Edit Inspection",
  no_inspections: "No inspections recorded",
  inspection_date: "Inspection Date",
  findings: "Findings",
  action_required: "Action Required",
  action_priority: "Action Priority",
  next_inspection: "Next Inspection",
  overdue: "Overdue",

  priority: {
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
  },

  photos: "Photos",
  add_photo: "Add Photo",

  // Navigation
  all_projects: "All Projects",
  favorites: "Favorites",
  new_project: "New Project",
  trees_short: "Trees",
  tree_cadastre: "Tree Cadastre",
  sensors_monitoring: "Sensors & Monitoring",
  tasks_workflows: "Tasks & Workflows",
  reports_analysis: "Reports & Analysis",

  // Tasks & Workflows
  new_task: "New Task",
  search_tasks: "Search tasks...",
  filter_tasks: "Filter",
  reset_filters: "Reset all",
  task_filter_measure_type: "Task type",
  task_filter_pruning_type: "Pruning type",
  task_filter_due_period: "Due period",
  task_filter_today: "Today",
  task_filter_this_week: "This week",
  task_filter_this_month: "This month",
  task_filter_overdue: "Overdue",
  measure_type_inspection: "Inspection",
  measure_type_irrigation: "Irrigation",
  measure_type_pruning: "Pruning",
  measure_type_sensor_maintenance: "Sensor Maintenance",
  measure_type_soil_maintenance: "Soil Maintenance",
  measure_type_free_entry: "Free entry",
  view_kanban: "Kanban",
  view_list: "List",
  view_calendar: "Calendar",
  stats_total: "Total tasks",
  stats_in_progress: "In progress",
  stats_completed: "Completed",
  stats_overdue: "Overdue",
  status_planned: "Planned",
  status_in_progress: "In progress",
  status_review: "In review",
  status_completed: "Completed",
  status_GEPLANT: "Planned",
  status_BEAUFTRAGT: "Commissioned",
  status_IN_ARBEIT: "In progress",
  status_ERLEDIGT: "Completed",
  status_NICHT_GESCHAFFT: "Not completed",
  priority_low: "Low",
  priority_medium: "Medium",
  priority_high: "High",
  task_title: "Title",
  task_title_placeholder: "Enter task title",
  task_description: "Description",
  task_description_placeholder: "Enter task description",
  task_assignee: "Assignee",
  task_assignee_select_placeholder: "Select assignee",
  task_tree_species: "Tree species",
  task_tree_species_placeholder: "Enter tree species",
  task_tree_location: "Tree & location",
  task_tree_info: "Tree information",
  task_tree_select: "Tree",
  task_tree_select_placeholder: "Select tree",
  task_location: "Location",
  task_location_placeholder: "Enter location",
  task_due_date: "Due date",
  task_priority: "Priority",
  project_name: "Project",
  task_status: "Status",
  task_comments: "Comments",
  task_attachments: "Attachments",
  create_task: "Create task",
  delete_task: "Delete",
  save_changes: "Save changes",
  add_comment: "Add comment",
  upload_file: "Upload file",
  cancel: "Cancel",
  no_tasks: "No tasks available",
  no_tasks_subtitle: "Create your first task",
  no_results: "No results",
  no_results_action: "Reset filters",
  tasks_completed_short: "completed",

  more_tasks: "more",
  month_january: "January",
  month_february: "February",
  month_march: "March",
  month_april: "April",
  month_may: "May",
  month_june: "June",
  month_july: "July",
  month_august: "August",
  month_september: "September",
  month_october: "October",
  month_november: "November",
  month_december: "December",
  day_monday: "Mon",
  day_tuesday: "Tue",
  day_wednesday: "Wed",
  day_thursday: "Thu",
  day_friday: "Fri",
  day_saturday: "Sat",
  day_sunday: "Sun",

  // Submenu items
  overview: "Overview",
  alerts: "Alerts",
  tree_inventory: "Tree Inventory",
  single_tree_view: "Single Tree View",
  master_data: "Master Data Management",
  documents: "Documents",
  import_export: "Import/Export",
  live_monitoring: "Live Monitoring",
  sensor_configuration: "Sensor Configuration",
  limits_alerts: "Limits & Alerts",
  data_graphs: "Data & Graphs",
  maintenance: "Maintenance",
  ticket_system: "Ticket System",
  resource_planning: "Resource Planning",
  condition_reports: "Condition Reports",
  cost_analysis: "Cost Analysis",
  development_trends: "Development Trends",
  risk_assessment: "Risk Assessment",
  interactive_map: "Interactive Map",
  heatmaps: "Heatmaps",
  area_management: "Area Management",

  // UI Elements
  open_sidebar: "Open Sidebar",
  close_sidebar: "Close Sidebar",
  keyboard_shortcuts: "Keyboard Shortcuts",
  navigation: "Navigation",
  general: "General",
  menu: "Menu",
  toggle_project_sidebar: "Toggle Project Sidebar",
  toggle_mobile_menu: "Toggle Mobile Menu",
  focus_search: "Focus Search",
  show_shortcuts: "Show Shortcuts",
  close_overlays: "Close Overlays",
  data_analysis: "Data Analysis",
  tree_form_info: {
    add_title: "Add Tree",
    edit_title: "Edit Tree",
    profile: {
      heading: "Tree Profile",
      cadastre_label: "Tree Cadastre No:",
      cadastre_help: "Optional registry identifier (max 24 characters).",
      name_label: "Name:",
      name_help: "Human-readable name (max 40 characters).",
      note: "You can edit these later in the tree details.",
    },
    position: {
      heading: "Position",
      latlng_label: "Latitude / Longitude*:",
      latlng_help: "Required. Enter coordinates or place the marker on the map.",
      altitude_label: "Altitude:",
      altitude_help: "Optional. Leave empty if unknown.",
      map_label: "Map:",
      map_help: "Use the map tools to zoom, pan, and set the exact position.",
      note: "Accurate coordinates improve analytics and maps.",
    },
    more: {
      heading: "More Info",
      phase_label: "Phase:",
      phase_help: "Choose Establishment, Development, or Maintenance.",
      year_label: "Planting Year:",
      year_help: "Select the year of planting.",
      species_label: "Tree Species:",
      species_help: "Search using “lat. name | common name”.",
      metrics_label: "Metrics:",
      metrics_help: "Trunk circumference (cm), height (m), crown diameter (m) — optional.",
      note: "Helpful for reporting and recommendations; can be added later.",
    },
    sensors: {
      heading: "Sensors",
      help: "Assign existing TreeSense sensors to this tree or remove assignments.",
      note: "Sensor assignments can also be changed later in the tree detail.",
    },
    represent: {
      heading: "Representative Tree",
      help: "Optionally declare that this tree represents others (clustering).",
    },
    soil: {
      heading: "Soil",
      pwp_label: "PWP:",
      pwp_help: "Permanent wilting point (e.g., 10).",
      max_nf_label: "Max. available water (max_nf):",
      max_nf_help: "Typical value e.g., 25.",
      max_f_label: "Field capacity (max_f):",
      max_f_help: "Typical value e.g., 45.",
      note: "Only needed if you work with soil-water estimations.",
    },
  },

  soil_info: {
    heading: "Understand soil parameters",
    intro: "These values describe the water-holding capacity of the soil at this location:",
    items: {
      pwp_label: "Permanent wilting point (PWP):",
      pwp_help: "Water content below which plants can no longer extract enough water and wilt.",
      efc_label: "Available water capacity (AWC):",
      efc_help: "Amount of water plants can actually take up (between PWP and field capacity).",
      fc_label: "Field capacity (FC):",
      fc_help: "Maximum water the soil can hold against gravity.",
    },
    note: "These parameters are configured per location and influence irrigation recommendations.",
  },
  health_state_info: {
    heading: "Traffic-light system: understand irrigation need",
    intro: "The traffic-light system shows at a glance whether a tree needs irrigation:",
    states: {
      green_label: "🟢 Green – No irrigation needed:",
      green_help: "The tree has sufficient water.",
      yellow_label: "🟡 Yellow – Irrigation recommended:",
      yellow_help: "Irrigate if operationally possible.",
      red_label: "🔴 Red – Irrigation urgently needed:",
      red_help: "Irrigate immediately!",
      gray_label: "⚪ Gray – Unknown:",
      gray_help: "Sensor unavailable or no data.",
      blue_label: "🔵 Blue – Too wet:",
      blue_help: "Over-irrigated; risk of waterlogging.",
    },
    note: "Important: The signal is based on measurements and configured thresholds for this tree, soil type, and location.",
  },
  pwp_info: {
    heading: "Permanent wilting point (PWP)",
    intro:
      "The permanent wilting point is the soil water content at which plants can no longer take up water.",
    when_reached: "When soil moisture reaches or drops below this value:",
    bullets: {
      a: "Plants can no longer absorb enough water",
      b: "Irreversible damage may occur",
      c: "Immediate irrigation is critical",
    },
    note: "Typical values: 10–15% (depends on soil type)",
  },
  efc_info: {
    heading: "Available water capacity (AWC)",
    intro: "The available water capacity is the amount of water actually available to plants.",
    formula_intro:
      "It is calculated as the difference between field capacity and permanent wilting point:",
    bullets: {
      a: "AWC = FC − PWP",
      b: "Represents plant-available water",
      c: "Important for irrigation planning",
    },
    note: "Higher values = soil can store more water and supply plants longer",
  },
  fc_info: {
    heading: "Field capacity (FC)",
    intro: "Field capacity is the maximum water the soil can hold against gravity.",
    after_rain: "After irrigation or rain:",
    bullets: {
      a: "Excess water percolates",
      b: "The soil settles at field capacity",
      c: "Best to start monitoring irrigation before PWP is reached",
    },
    note: "Typical values: 35–50% (depends on soil type)",
  },
  map_sidebar_info: {
    title: "Map view – Areas and Trees",
    heading: "Navigation in the map view",
    description: "This sidebar lists all irrigation areas and their trees in a hierarchical view.",
    features_heading: "Features:",
    features: {
      expand_areas_label: "Expand areas:",
      expand_areas_help: "Click an area to show all associated trees.",
      select_tree_label: "Select a tree:",
      select_tree_help: "Click a tree to show it on the map and open its details.",
      add_tree_label: "Add a tree:",
      add_tree_help: "Use the plus icon to add new trees to an area.",
      parent_child_label: "Parent–child relations:",
      parent_child_help:
        "Trees with sensors can act as parent trees and represent additional trees.",
    },
    note: "Tree color-coding reflects health status (green = healthy, yellow = drying, red = dry, gray = unknown).",
  },

  // Filter overlay
  filter_by_project: "Filter by Project",
  clear_filter: "Clear Filter",
  date_time: "Date/Time",
  other: "Other",
  project_not_found: "Project not found",
  tree_water_deficit: "Tree water deficit",
  diameter_minus_start: "Diameter change since start",
  tree_info_help: {
    heading: "What you see here",
    description:
      "This tab shows the selected tree’s master data (species, dimensions, location and status). It provides context for sensor readings and maintenance history.",
    fields_heading: "Field explanations",
    fields: {
      species_label: "Species:",
      species_help: "Scientific name (and common name if available).",
      dimensions_label: "Dimensions:",
      dimensions_help:
        "Height, crown diameter and trunk circumference as last recorded (inventory values).",
      year_phase_label: "Planting year & phase:",
      year_phase_help:
        "Planting year (may be estimated) and lifecycle phase such as establishment, development or ageing phase.",
      location_label: "Location / coordinates:",
      location_help:
        "WGS84 latitude/longitude used to place the tree on the map. Accuracy depends on the underlying inventory data.",
      status_label: "Tree status:",
      status_help:
        "Current assessment (e.g. no drought stress / drought stress). Depending on project settings, this can be derived from sensor data or manual evaluation.",
    },
    note: "Tip: You can edit master data via the pencil icon if you have the required permissions.",
  },

  load_data: "Load Data",
  search_area: "Search Area",
  change: "Change",
  download: "Download",
  qr_scanner: "QR Scanner",
  select_camera: "Select camera",

  edit_customer: "Edit customer",
  cloase_area_list: "Close area list",
  confirm_delete: "Confirm delete",
  create_customer: "Create customer",
  downloading: "Downloading…",
  inspector: "Inspector",
  installation: "Installation",
  installed_sensors: "Installed sensors",
  loading_trees: "Loading trees…",
  manage_parent_child_relationships: "Manage parent–child relationships",
  manage_trees_without_sensors: "Manage trees without sensors",
  next_inspection_date: "Next inspection date",
  no_sensor_mode: "No-sensor mode",
  no_trees_available: "No trees available",
  not_found: "Not found",
  open: "Open",
  parent_child_mode: "Parent–child mode",
  projects_views: "Projects",
  reset: "Reset",
  risklevel: "Risk level",
  search: "Search",
  search_address: "Search address",
  select_child_trees: "Select child trees",
  sensors_views: "Sensors",
  start_scanning: "Start scanning",
  treeNoSensor: "Tree without sensor",
  tree_management_mode: "Tree management mode",
  trees_views: "Trees",
  type_an_adress: "Type an address",

  proj: "Project",
  creating: "creating",
  customer_name: "Customer Name",

  bark_condition_label: "Bark condition",

  damage_severity_label: "Damage severity",
  date: "Date",
  more_actions: "More actions",
  view_on_map: "Open on map",
  view_on_list: "Open in list",
  view_on_chart: "Open in Data Science",
  tree_and_sensor: "Tree & Sensor",
  rainfall_mm: "Rainfall (mm)",
  zoom_in: "Zoom in",
  reset_zoom: "Reset zoom",
  restore_view: "Restore view",
  download_project_csv: "Download project data (TSV files)",
  download_project_data: "Download all sensor data for this project",

  inspection_result_label: "Inspection result",

  inspection_type_label: "Inspection type",
  foliagedensity: "Foilage Density",
  error_loading_customers: "Error loading customers",
  recommendations: "Recommendations",
  error_loading_trees: "Error loading trees",
  error_loading_users: "Error loading users",
  growth_rate_label: "Growth rate",
  close_areas_list: "Close areas list",
  customer_creation_code: "Customer creation code",
  value: "Value",
  variables: "Variables",
  password_reset_request_sent_generic:
    "If an account exists for this email, we'll send a reset link.",
  position_confirmed: "Position confirmed",
  use_my_location: "Use my location",
  assessment_date: "Assessment Date",
  confirm_delete_task_message: "Are you sure you want to delete this task?",
  bark_condition: {
    healthy: "Healthy",
    minor_damage: "Minor Damage",
    moderate_damage: "Moderate Damage",
    severe_damage: "Severe Damage",
  },
  damage_severity: {
    none: "None",
    light: "Light",
    moderate: "Moderate",
    severe: "Severe",
    critical: "Critical",
  },
  foliage_density: {
    full: "Full",
    moderate: "Moderate",
    sparse: "Sparse",
    very_sparse: "Very Sparse",
  },
  growth_rate: {
    vigorous: "Vigorous",
    normal: "Normal",
    slow: "Slow",
    stagnant: "Stagnant",
  },
  inspection_result: {
    passed: "Passed",
    passed_with_notes: "Passed with Notes",
    failed: "Failed",
  },

  inspection_type: {
    routine: "Routine Inspection",
    safety: "Safety Inspection",
    detailed: "Detailed Inspection",
    emergency: "Emergency Inspection",
    post_storm: "Post-storm Inspection",
  },
  install_sensor: "Install sensor",
  history: "History",
  sesnor_height_hint: "Drag the sensor icon or enter the height. Values are rounded.",
  care_chat: {
    measure_irrigation: "Irrigation",
    measure_pruning: "Pruning measure",
    measure_inspection: "Regular inspection",
    measure_free: "Free entry",
    sensor_install_task: "Mount sensor on tree",
    sensor_maintenance_task: "Perform sensor maintenance on tree",
    add_entry: "Add entry",
    fill_checklist: "Fill checklist",
    fill_protocol: "Fill protocol",
    select_placeholder: "Select",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    yes: "Yes",
    no: "No",
    responsible_person: "Responsible person",
    responsible_person_required: "Responsible person (required)",
    short_description_optional: "Short description (optional)",
    short_description_placeholder: "Short description",
    datetime: "Date & Time",
    date: "Date",
    today: "Today",
    tomorrow: "Tomorrow",
    in_one_week: "In one week",
    in_one_month: "In one month",
    time: "Time",
    remarks: "Remarks",
    cost_center: "Cost centre",
    assignment: "Assignment",
    description: "Description",
    please_select_person: "Please select a person.",
    future_date_required: "Please choose a future date and time.",
    please_provide_type: "Please provide a type.",
    please_provide_tree_condition: "Please provide tree condition.",
    weather_sunny: "sunny",
    weather_cloudy: "cloudy",
    weather_rain_before: "rain before",
    weather_rain_after: "rain after",
    weather_windy: "windy",
    weather_dry: "dry",
    soil_dry: "dry",
    soil_slightly_moist: "slightly moist",
    soil_wet: "wet",
    tree_condition_healthy: "healthy",
    tree_condition_wilted_leaves: "wilted leaves",
    tree_condition_damage: "damage",
    tree_condition_tilt: "tilt",
    tree_condition_other: "other",
    irrigation_protocol_title: "Fill irrigation protocol",
    water_amount_liters: "Water amount (litres)",
    water_amount_required: "Please enter the water amount.",
    irrigation_method: "Irrigation method",
    irrigation_method_placeholder: "e.g. manual, watering bag, tanker",
    reason: "Reason / occasion",
    reason_placeholder: "regular, drought, ...",
    weather_conditions: "Weather conditions",
    soil_moisture: "Soil moisture",
    tree_condition: "Tree condition",
    tree_condition_required: "Tree condition (required)",
    tree_condition_placeholder: "e.g. healthy, damage, fungal infection",
    pruning_protocol_title: "Fill pruning protocol",
    pruning_type: "Type of pruning measure",
    pruning_type_required: "Type of pruning measure (required)",
    pruning_formative: "Formative pruning",
    pruning_maintenance: "Maintenance pruning",
    pruning_crown_reduction: "Crown reduction / crown care",
    pruning_clearing: "Clearing / freecutting",
    pruning_remedial: "Remedial pruning (restorative / corrective)",
    pruning_safety: "Safety pruning (traffic safety pruning)",
    inspection_title: "Document regular inspection",
    inspection_data: "Inspection data",
    inspected_by: "Inspected by",
    interval_years: "Interval (years)",
    next_inspection: "Next inspection",
    road_safe: "Road safe",
    further_action_title: "Further action",
    action_required: "Action required",
    consult_specialist: "Consultation with specialist department",
    detailed_investigation: "Detailed investigations",
    tree_care_measures: "Tree care measures",
    tree_care_measures_hint: "e.g. dead wood removal, clearance pruning, crown stabilization",
    inspection_intervals: "Inspection intervals",
    interval_future_every: "in future every",
    interval_years_annual: "years / annually",
    interval_as_before: "as before",
    felling: "Felling",
    completion: "Completion",
    immediately: "immediately",
    within: "within",
    weeks: "weeks",
    remarks_label: "Remarks",
    fill_form: "Fill out form",
    upload_document: "Upload document",
    upload_document_hint: "Drop PDF, image or document here, or click to select",
    remove: "Remove",
    follow_up_inspection: "Regular inspection (follow-up)",
    remark_optional: "Remark (optional)",
    status_planned: "Planned",
    status_commissioned: "Commissioned",
    status_in_progress: "In progress",
    status_done: "Done",
    status_not_done: "Not done",
    priority: "Priority",
    priority_low: "Low",
    priority_medium: "Medium",
    priority_high: "High",
    priority_critical: "Critical",
    amount: "Amount:",
    method: "Method:",
    cut_type: "Cut type:",
    scope: "Scope:",
    inspection_level: "Inspection level:",
    finding: "Finding:",
    recommendation: "Recommendation:",
    reason_display: "Reason:",
    executor: "Executor:",
    deadline: "Deadline:",
    cost_center_display: "Cost centre:",
    assignment_display: "Assignment:",
    description_display: "Description:",
    irrigation_log_title: "Irrigation protocol",
    datetime_display: "Date / Time:",
    water_amount_display: "Water amount:",
    irrigation_method_display: "Irrigation method:",
    reason_label: "Reason / occasion:",
    weather_display: "Weather conditions:",
    soil_moisture_display: "Soil moisture:",
    tree_condition_display: "Tree condition:",
    responsible_person_display: "Responsible person:",
    remarks_display: "Remarks:",
    pruning_log_title: "Pruning protocol",
    pruning_type_display: "Type:",
    inspected_by_display: "Inspected by:",
    inspection_date_display: "Inspection date:",
    next_inspection_display: "Next inspection:",
    interval_display: "Interval:",
    road_safe_display: "Road safe:",
    remark_display: "Remark:",
    attachment_display: "Attachment:",
    show_less: "Show less",
    show_more: "Show more",
    all_statuses: "All statuses",
    all_priorities: "All priorities",
    all_types: "All types",
    sort_by_date: "Sort by date",
    sort_by_priority: "Sort by priority",
    add_photo: "Add photo",
    no_entries_found: "No entries found.",
    no_tasks_found: "No tasks found.",
    next_inspection_label: "Next inspection:",
    no_inspection_planned: "No inspection planned.",
    plan_inspection: "Plan inspection",
    perform_inspection: "Perform inspection",
    delete: "Delete",
    appointment_label: "Appointment:",
    edit: "Edit",
    mark_not_done: "Mark as not done",
    mark_done: "Mark as done",
    favorite: "Favourite",
    reschedule: "Reschedule",
    reschedule_title: "Reschedule appointment",
    overdue_since_days: "Overdue for {{days}} days",
    in_days: "In {{days}} days",
    overdue_since_hours: "Overdue for {{hours}} hrs.",
    in_hours: "In {{hours}} hrs.",
  },
  change_position: "Change position",
  remove: "Remove",
  water_stress: "Water stress",
  install: "Install",
  thresholds: "Thresholds",
  cookie_consent: {
    banner_title: "Cookie Settings",
    banner_description:
      "We use cookies to provide you with the best possible experience on our website. You can customize your preferences or accept all cookies.",
    accept_all: "Accept All",
    accept_essential: "Essential Only",
    customize: "Customize",
    save_preferences: "Save Preferences",
    essential_cookies: "Essential Cookies",
    essential_cookies_description:
      "These cookies are essential for the website to function and cannot be disabled. They are usually only set in response to actions you take, such as setting your privacy preferences, logging in, or filling out forms.",
    analytics_cookies: "Analytics Cookies",
    analytics_cookies_description:
      "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our website. They help us understand which pages are most popular and how visitors move around the site.",
    marketing_cookies: "Marketing Cookies",
    marketing_cookies_description:
      "These cookies may be set by our advertising partners through our website. They may be used to build a profile of your interests and show you relevant advertising on other websites.",
    preferences_cookies: "Preference Cookies",
    preferences_cookies_description:
      "These cookies enable the website to remember your choices (such as your username, language, or region) and provide enhanced, more personalized features.",
    cookie_policy: "Cookie Policy",
    privacy_policy: "Privacy Policy",
    settings_title: "Cookie Settings",
    settings_description: "Manage your cookie preferences. Changes will take effect immediately.",
    last_updated: "Last updated",
    preferences_saved: "Your cookie preferences have been saved.",
    preferences_error: "Error saving preferences.",
  },
  tree_wiki: "Tree Wiki",
  sensor_already_installed: "This sensor is already actively installed.",
  please_select_sensor: "Please select a sensor.",
  installation_save_failed: "Could not save installation. Please try again.",
  beta_ended: {
    title: "Beta Phase Ended",
    subtitle: "The test phase is over",
    description:
      "Thank you for using the beta version! All changes and improvements from the beta phase have been implemented and are now available in the TreeSense Cloud.",
    link_text: "Go to TreeSense Cloud",
  },
  improvements: "Improvements",
  moisture_formula_setting: "Moisture Content Formula",
  use_new_moisture_formula: "Use new formula",
  moisture_formula_hint:
    "The new formula compensates for temperature effects better and provides more stable values.",
  new_formula: "New Formula",
  old_formula: "Old Formula",
  moisture_formula_new_description:
    "Generally more stable as it better compensates for temperature effects. However, this may make irrigation events or rain events less noticeable.",
  moisture_formula_old_description:
    "More affected by temperature fluctuations, but may show irrigation and rain events more clearly.",
  moisture_formula_improvements:
    "We have significantly improved and automated the temperature calibration setup. Previously, only black poplar was compensated. Now we attempt to compensate for as many tree species as possible. If this is not possible, we use the phylogenetically closest tree species.",
  moisture_formula_threshold_warning:
    "When using the new formula, the thresholds also change. They need to be reviewed and adjusted after switching so that warnings and evaluations remain correct.",
  moisture_formula_learn_more: "Learn more",
  moisture_formula_wiki_link:
    "https://www.treesense.net/wiki_post/treesense-pulse-was-ist-der-treesense-feuchtigkeitsindex/",
  moisture_formula_note:
    "Note: The choice of formula affects the display of moisture values in all charts.",
  moisture_content_display_setting: "Moisture content display",
  moisture_content_display_description: "Choose how TreeSense shows moisture content values.",
  moisture_content_display_fraction: "Fraction (0-1)",
  moisture_content_display_fraction_description: "Display values as 0.34.",
  moisture_content_display_percent: "Percent (0-100)",
  moisture_content_display_percent_description: "Display values as 34%.",
  moisture_content_cap_setting: "Cap moisture content values",
  moisture_content_cap_description:
    "Limit values to 0-1 / 0-100%. Disable to show raw analytical values.",
  table_column_preferences: "Visible columns",
  table_column_preferences_hint:
    "Choose which columns are shown in the trees, sensors, and tasks tables.",
  mobile_table_column_preferences: "Mobile columns",
  mobile_table_column_preferences_hint:
    "Choose which 2 columns are shown on mobile devices (smartphones).",
  mobile_column: "Column",
  table_columns_trees: "Trees",
  table_columns_sensors: "Sensors",
  table_columns_tasks: "Tasks",
  reset_table_column_preferences: "Restore defaults",
  move_up: "Move up",
  move_down: "Move down",
  settings_saved_successfully: "Settings saved successfully",
  action: "Action",
  back: "Back",
  download_successful: "Download successful",
  evaluation: "Evaluation",
  filter: "Filter",
  from: "From",
  inactive: "Inactive",
  info: "Info",
  last_date: "Last Date",
  more_information: "More Information",
  no_data_found: "No data found",
  no_sensors_found: "No sensors found",
  position: "Position",
  refresh_health: "Refresh health data",
  refresh_health_error: "Failed to refresh health data",
  required: "Required",
  select_sensor_search: "Search for sensor...",
  something_wrong: "Something went wrong",
  start_typing_to_search: "Start typing to search...",
  to: "To",
};
